<div
  class="ds-returns {{size}}"
  [ngClass]="type === 'custom' ? 'custom' : value === 0 ? 'neutral' : value > 0 ? 'positive' :'negative'"
  [style]="'--custom-color:' + customColor"
>
  <ion-icon name="arrow-up-outline" *ngIf="value > 0"></ion-icon>
  <ion-icon name="arrow-down-outline" *ngIf="value < 0"></ion-icon>
  <span [ngClass]="{'ds-caption-1': size === 'medium', 'ds-caption-3': size === 'small'}">
    {{ value.toString().replace('-','') | percent:'1.2-2' }}
  </span>
</div>
